<template>
  <span class="locale-flag" :class="size" :title="title" role="img" :aria-label="title || flagAlt">
    <img
      :src="flagSrc"
      :alt="flagAlt"
      class="locale-flag-img"
      loading="lazy"
      decoding="async"
    />
  </span>
</template>

<script setup>
import { computed } from 'vue'
import flagPt from '../assets/idiomas/portugues.png'
import flagEs from '../assets/idiomas/espanhol.png'
import flagEn from '../assets/idiomas/ingles.png'

const props = defineProps({
  code: {
    type: String,
    required: true,
    validator: (v) => ['pt-BR', 'es', 'en'].includes(v)
  },
  size: {
    type: String,
    default: 'md'
  },
  title: {
    type: String,
    default: ''
  }
})

const FLAG_BY_CODE = {
  'pt-BR': flagPt,
  es: flagEs,
  en: flagEn
}

const flagSrc = computed(() => FLAG_BY_CODE[props.code] || flagPt)

const flagAlt = computed(() => {
  if (props.title) return props.title
  const labels = {
    'pt-BR': 'Português',
    es: 'Español',
    en: 'English'
  }
  return labels[props.code] || 'Idioma'
})
</script>

<style scoped>
.locale-flag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: none;
  border-radius: 0;
  overflow: visible;
  box-shadow: none;
}

.locale-flag-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border: none;
  outline: none;
  box-shadow: none;
}

.locale-flag.sm {
  width: 1.35rem;
  height: 1.35rem;
}

.locale-flag.md {
  width: 1.5rem;
  height: 1.5rem;
}

.locale-flag.lg {
  width: 1.75rem;
  height: 1.75rem;
}
</style>
